
import { useState } from "react";
import { useDocumentsManager } from "@/hooks/useDocumentsManager";
import { DocumentsPageHeader } from "@/components/documents/DocumentsPageHeader";
import { Loader2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { DocumentTabNavigation } from "@/components/documents/DocumentTabNavigation";
import { DocumentGridView } from "@/components/documents/DocumentGridView";
import { FAQSection } from "@/components/documents/faq/FAQSection";

const MANDATORY_SECTIONS = ['Stadgar', 'Ordningsregler', 'FAQ'];

const DocumentsPage = () => {
  const { t } = useLanguage();
  const {
    sections,
    documents,
    selectedSection,
    isLoadingSections,
    isLoadingDocuments,
    organizationId,
    setSections,
    setSelectedSection,
    handleSectionSelect,
    handleDocumentDeleted,
    handleDocumentUploaded,
    handleDocumentUpdated,
    handleSectionDeleted,
    handleDownload
  } = useDocumentsManager();
  
  const [showCreateForm, setShowCreateForm] = useState(false);

  if (!organizationId) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center pb-20 md:pb-0">
        <Loader2 className="h-8 w-8 animate-spin text-[#2F80ED]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pb-20 md:pb-0">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8 py-4 sm:py-6 lg:py-8">
        <DocumentsPageHeader 
          onSectionCreated={(section) => {
            setSections([...sections, section]);
          }}
          organizationId={organizationId}
        />
        
        <div className="mb-6">
        <DocumentTabNavigation 
          sections={sections}
          selectedSection={selectedSection}
          onSectionSelect={handleSectionSelect}
          mandatorySections={MANDATORY_SECTIONS}
          isLoading={isLoadingSections}
          onSectionRenamed={(sectionId, newName) => {
            setSections(sections.map(s => 
              s.id === sectionId ? { ...s, name: newName } : s
            ));
          }}
          onSectionDeleted={handleSectionDeleted}
          isAdmin={true}
        />
        </div>
        
        {selectedSection ? (
          selectedSection.section_type === 'FAQ' ? (
            <FAQSection organizationId={organizationId!} sectionId={selectedSection.id} isAdmin={true} />
          ) : (
            <div className="bg-white border border-border rounded-lg shadow-sm">
              <DocumentGridView
                selectedSection={selectedSection}
                documents={documents}
                onDocumentDeleted={handleDocumentDeleted}
                onDocumentUploaded={handleDocumentUploaded}
                onDocumentUpdated={handleDocumentUpdated}
                isMandatorySection={MANDATORY_SECTIONS.includes(selectedSection.name)}
                onDownload={handleDownload}
                isLoadingDocuments={isLoadingDocuments}
                organizationId={organizationId}
              />
            </div>
          )
        ) : (
          <div className="bg-white border border-border rounded-lg shadow-sm p-6 sm:p-8 text-center">
            <p className="text-muted-foreground text-base">
              {t('documents.select_section')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentsPage;
